import { useQuery } from "react-query";
import { fetchAdminStats } from "../queries/auth.queries";

export const useAdminStats = (
	interval: "week" | "month" | "year",
	date: Date,
) => {
	return useQuery({
		queryKey: ["admin-stats", interval, date],
		queryFn: async () => {
			try {
				return fetchAdminStats(interval, date);
			} catch (err) {
				return null;
			}
		},
	});
};
